import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import 'hammerjs';
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { environment } from '../environments/environment';

// Material design components
import { MdButtonModule, MdToolbarModule, MdCardModule, MdInputModule, MdDialogModule, MdListModule, MdProgressSpinnerModule, MdSnackBarModule } from '@angular/material';

// App service
import { AuthService } from './core/auth.service';

// Auth guard
import { AuthGuard } from './core/auth.guard';

// App components
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordDialogComponent } from './login/forgot-password-dialog/forgot-password-dialog.component';
import { PickupComponent } from './pickup/pickup.component';
import { SettingsComponent } from './settings/settings.component';

const appRoutes: Routes = [
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'pickup/:id', component: PickupComponent, canActivate: [AuthGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent }
]

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ForgotPasswordDialogComponent,
    PickupComponent,
    SettingsComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    MdButtonModule,
    MdToolbarModule,
    MdCardModule,
    MdInputModule,
    MdDialogModule,
    MdListModule,
    MdProgressSpinnerModule,
    MdSnackBarModule,
    NgxDatatableModule
  ],
  providers: [
    AuthService,
    AuthGuard
  ],
  bootstrap: [AppComponent],
  entryComponents: [ForgotPasswordDialogComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts